<template>
    <div class="row">
        <div id="chart" class="col-md-12">
            <widget-chart v-if="chart != null" :key="redraw" :widget="chart" @close-chart="closeChart"></widget-chart>            
        </div>
        
        <template v-if="dashboard.widgets != undefined && dashboard.widgets.length > 0">
            <template v-for="(widget, key) in dashboard.widgets">
                <widget-01 v-if="widget.type == '01'" :widget="widget" :key="key" @open-chart="openChart"></widget-01>
                <widget-02 v-else-if="widget.type == '02'" :widget="widget" :key="key" @open-chart="openChart"></widget-02>
                <widget-03 v-else-if="widget.type == '03'" :widget="widget" :key="key" @open-chart="openChart"></widget-03>
                <widget-04 v-else-if="widget.type == '04'" :widget="widget" :key="key" @open-chart="openChart"></widget-04>
                <widget-05 v-else-if="widget.type == '05'" :widget="widget" :key="key" :id="'synoptic' + key"></widget-05>
                <widget-06 v-else-if="widget.type == '06'" :widget="widget" :key="key" @open-chart="openChart"></widget-06>
                <widget-07 v-else-if="widget.type == '07'" :widget="widget" :key="key" @open-chart="openChart"></widget-07>
                <widget-10 v-else-if="widget.type == '10'" :widget="widget" :key="key" @open-chart="openChart"></widget-10>
                <widget-11 v-else-if="widget.type == '11'" :widget="widget" :key="key" @open-chart="openChart"></widget-11>
            </template>            
        </template>        
    </div>
</template>

<script>
    import Widget01 from './Widgets/01.vue';
    import Widget02 from './Widgets/02.vue';
    import Widget03 from './Widgets/03.vue';
    import Widget04 from './Widgets/04.vue';
    import Widget05 from './Widgets/05.vue';
    import Widget06 from './Widgets/06.vue';
    import Widget07 from './Widgets/07.vue';
    import Widget10 from './Widgets/10.vue';
    import Widget11 from './Widgets/11.vue';
    import WidgetChart from './Widgets/Chart.vue';

    export default {

        components: {Widget01, Widget02, Widget03, Widget04, Widget05, Widget06, Widget07, Widget10, Widget11, WidgetChart},

        props: ['dashboard'],
        
        data() {
            return {
                chart: null,
                widgets: [],
                redraw: null                
            }
        },

        methods: {
            openChart(widget) {
                this.$set(this, 'chart', widget);

                this.redrawChart();

                this.$scrollTo('#chart', {offset: -20});
            },

            redrawChart() {
                this.redraw = (((1+Math.random())*0x10000)|0).toString(16).substring(1);
            },

            closeChart() {
                this.$set(this, 'chart', null);
            }
        }
    }
</script>
